import { render, staticRenderFns } from "./DraftsStudentModule.vue?vue&type=template&id=fef693b6&scoped=true"
import script from "./DraftsStudentModule.vue?vue&type=script&lang=js"
export * from "./DraftsStudentModule.vue?vue&type=script&lang=js"
import style0 from "./DraftsStudentModule.vue?vue&type=style&index=0&id=fef693b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef693b6",
  null
  
)

export default component.exports